/**
 * A typed identifier ("LEI 9845FRUU…"), the only basis for entity matching:
 * a name is never treated as proof of identity (GAP-TP-017).
 */
export function IdentifierTag({ type, value }: { type: string; value: string }) {
  return (
    <span className="inline-flex max-w-full items-center overflow-hidden rounded-sm border border-line text-xs">
      <span className="shrink-0 border-r border-line bg-wash px-1.5 py-0.5 font-semibold text-teal-800">
        {type}
      </span>
      <span className="min-w-0 truncate px-1.5 py-0.5 font-mono text-ink">{value}</span>
    </span>
  )
}
